import React from 'react'

function InvoiceFooter({invoiceDetails,companyDetails,customerDetails}) {
  return (
    invoiceDetails && companyDetails && customerDetails &&
    <div className='row'>
        {invoiceDetails.declaration !== "" &&
            <div className='col-12' style={{fontSize:12}}>
                <span className="fw-bold me-2" >Declaration : </span>{invoiceDetails.declaration}
            </div>
        }
        {invoiceDetails.terms !== "" &&
            <div className='col-12' style={{fontSize:12}}>
                <span className="fw-bold me-2" >Terms : </span>{invoiceDetails.terms}
            </div>
        }
        <div className='col-6'>
            <table className='table table-striped table-bordered table-sm' style={{fontSize:12}}>
                <thead>
                    <tr>
                        <th colSpan={2} className='text-center'>
                            Company's Bank Details
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>A/C Holder Name</td>
                        <th>{companyDetails.bankAccountHolderName}</th>
                    </tr>
                    <tr>
                        <td>Bank Name</td>
                        <th>{companyDetails.bankName}</th>
                    </tr>
                    <tr>
                        <td>Account Number</td>
                        <th>{companyDetails.bankAccountNumber}</th>
                    </tr>
                    <tr>
                        <td>Branch & Ifsc</td>
                        <th>{companyDetails.bankBranch} {companyDetails.bankIfsc}</th>
                    </tr>

                    <tr>
                        <td>SWIFT Code</td>
                        <th>{companyDetails.bankSwift}</th>
                    </tr>

                    
                </tbody>
            </table>
        </div>

        <div className='col-6'>
            <table className='table table-sm' style={{fontSize:12}}>
                <tbody>
                    <tr>
                        <td>Company's Pan</td>
                        <th>{companyDetails.pan}</th>
                    </tr>
                    
                </tbody>
            </table>
            <div className='card' style={{fontSize:12}}>
                <div className='card-body p-1'>
                <div className='float-end'>
                    <div className='fw-bold'>for {companyDetails.companyName}</div>
                    <img src={companyDetails.authSign} style={{ maxWidth:".75in",maxHeight:".75in",}} />
                    <div>Authorised Signatory</div>
                </div>
                </div>
            </div>
        </div>
        <div className='col-md-12 text-center' style={{fontSize:12}}>This is a Computer Generated Invoice</div>
    </div>
  )
}

export default InvoiceFooter